import { Injectable } from '@angular/core';
import { OrdersService, OrderULResponse } from '@cemex-core/cmx-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError, filter, take } from 'rxjs/operators';
import {
  SimulateActionTypes,
  SimulateLoadCompleteAction,
  SimulateResetAction,
} from '@ordersnproducts/modules/order-builder/modules/rms-summary/actions/open-platform/simulate.actions';
import { CmxClientService } from '@cemex/cmx-client-layout';
import { TranslateService } from '@ngx-translate/core';
import { ULOrderRequestSolverService } from '@ordersnproducts/modules/order-builder/modules/rms-summary/solvers/ul-order-request-solver.service';
// import { Mark } from '@ordersnproducts/modules/shared/constants/mark';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { getActiveExperienceCode, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';

@Injectable()
export class SimulateOPEffects {
  simulateOP$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(SimulateActionTypes.LOAD),
      switchMap(() => {
        return this.store.select(getActiveExperienceCode).pipe(
          take(1),
          filter(
            (expCode) =>
              (!!expCode && expCode === ORDER_EXPERIENCES.RMX_UNIVERSAL_LINK) ||
              expCode === ORDER_EXPERIENCES.ARKIK_UNIVERSAL_LINK ||
              expCode === ORDER_EXPERIENCES.COMMAND_UNIVERSAL_LINK,
          ),
          switchMap((expCode) =>
            this.rmsULOrderRequestSolverService.createULOrderRequest(expCode as ORDER_EXPERIENCES),
          ),
          switchMap((request) => {
            return this.rmsULOrderRequestSolverService.createULOrderReqHeaders(true).then((addHeaders) => {
              return { request, addHeaders };
            });
          }),
          switchMap((requestObj) => {
            this.alerts.addMainAlert('info', this.translate.instant('views.checkout.validating_order'));
            return this.ordersService.createULOrder(requestObj.request, requestObj.addHeaders).pipe(
              map((order: OrderULResponse) => {
                this.alerts.closeAllAlerts();
                // TODO: define how to handle prices info
                // const taxes = Number(order.MT_Orders_resp.Orders[0].OrderTax);
                // const netValue = Number(order.MT_Orders_resp.Orders[0].OrderNetValue);
                // const total = taxes + netValue;
                // const isValidPrice = total > 0;
                // if (!isValidPrice) {
                //   this.alerts.addMainAlert('danger', this.translate.instant('views.checkout.prices_error'));
                // }

                const isValidOrder = _safe(() => order.orderId > 0, false);
                if (!isValidOrder) {
                  this.alerts.addMainAlert('danger', this.translate.instant('views.checkout.validating_order_error'));
                }

                return new SimulateLoadCompleteAction(order);
              }),
              catchError((error) => {
                console.error(error);
                this.alerts.addMainAlert('danger', this.translate.instant('views.checkout.validating_order_error'));
                return of(new SimulateResetAction());
              }),
            );
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private alerts: CmxClientService,
    private ordersService: OrdersService,
    private translate: TranslateService,
    private rmsULOrderRequestSolverService: ULOrderRequestSolverService,
    private store: Store<OrderBuilderState>,
  ) {}
}
